import React from 'react'
import PropTypes from 'prop-types'
import Smartview from 'widgets/smartviews/Smartview'
import { Collection, ForEachModel } from '@morningtrain/react-resources'
import { SearchFilter, StaticFilter } from '@morningtrain/react-filters'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import SupplierCategoryItem from 'widgets/smartviews/inventory/SupplierCategoryItem'
import { VerticalList } from 'ui/layouts'

export default function SupplierCategorySmartview (props) {
  const { categoryId, categoryName } = props

  return (
    <Smartview header={categoryName}>
      <Collection resourceName='inventory.item' operationName='options'>
        <SearchFilter />
        <StaticFilter name='inventory_category_id' value={categoryId} />
        <SmartviewContentSeparator />
        <VerticalList>
          <ForEachModel>
            <SupplierCategoryItem categoryId={categoryId} />
          </ForEachModel>
        </VerticalList>
      </Collection>

    </Smartview>
  )
}

SupplierCategorySmartview.propTypes = {
  categoryId: PropTypes.number.isRequired,
  categoryName: PropTypes.string.isRequired
}
